import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PolicyBriefing from "@/pages/PolicyBriefing";
import Orchards from "@/pages/Orchards";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-sand text-charcoal">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/policy-briefing" element={<PolicyBriefing />} />
          <Route path="/orchards" element={<Orchards />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1C1917",
            color: "#F8F6F0",
            border: "1px solid #44403C",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
